export function isContractEligibleForClinicUse(contract) {
  let isEligible = false;

  if (contract.packageTier === 'premium_mix' && ['S', 'M', 'L', 'PPU'].includes(contract.packageSize)) {
    isEligible = true;
  }

  if (contract.packageTier === 'deluxe_mix' && ['M', 'L', 'PPU'].includes(contract.packageSize)) {
    isEligible = true;
  }

  return isEligible;
}
